import _extends from "@babel/runtime/helpers/esm/extends";
import Modal from './Modal';
import { confirm, success, info, error, warning, destroyAll } from './dialog';
export default _extends(Modal, {
  confirm: confirm,
  success: success,
  info: info,
  error: error,
  warning: warning,
  destroyAll: destroyAll
});